import { Image, Link, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import CustomLink from '../Common/CustomLink';

const SnsCard = ({ item }) => {
  return (
    <div className="sns_card_col">
      <div className="card_info_div">
        <img
          className="sns-card-img"
          src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/category/snsCardBg.png"
          width="100%"
          height="100%"
        />
        <div className="overlayContent_sns">
          <div className="snsOverlay_row">
            <div className="content_wrap_sm">
              <h2 className="card_tagsns">
                {' '}
                <Text field={item?.fields?.SubHeading} editable />{' '}
              </h2>
              <div className="sns_card_heading">
                <Text field={item?.fields?.Heading} editable />
              </div>
              <RichText tag="ul" className="cat_banner_ul" field={item?.fields?.Content} editable />
              <div className="sns_buttons_group">
                {item?.fields?.CTALink && <CustomLink className="get_started_sns know_more_sns" field={item?.fields?.CTALink} />}
                {item?.fields?.CTALink1 && <CustomLink className="get_started_sns" field={item?.fields?.CTALink1} />}
              </div>
            </div>
            <div className="card_upImg">
              <Image className="sns-cardUp-img" field={item?.fields?.Image} loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Portfolio = ({ fields }) => {
  const data = fields.Portifolios;
  return (
    <>
      <section className="sns_card_section sec_padding_cm" id={fields?.StickyNavId?.value}>
        {}
        <div className="sns_card_inner">
          <div className="cus-container">
            <div className="sns_card_row">
              {data.map((item, index) => (
                <SnsCard key={item.id} item={item} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Portfolio;
